module.exports = __webpack_public_path__ + "static/media/millennium_falcon@3x.b6682587.png";